import { Users } from "@graylog/server-api";
import UserNotification from "util/UserNotification";
import { CurrentUserStore } from "stores/users/CurrentUserStore";
const convertPreferences = (preferences) => {
  const convertedPreferences = {};
  Object.entries(preferences).forEach(([key, value]) => {
    if (value === "true") {
      convertedPreferences[key] = true;
    } else if (value === "false") {
      convertedPreferences[key] = false;
    } else {
      convertedPreferences[key] = value;
    }
  });
  return convertedPreferences;
};
export const saveUserPreferences = (userName, preferences, callback = () => {
}, displaySuccessNotification = true) => {
  const convertedPreferences = convertPreferences(preferences);
  return Users.savePreferences(encodeURIComponent(userName), { preferences: convertedPreferences }).then(
    () => {
      if (displaySuccessNotification) {
        UserNotification.success("User preferences successfully saved");
      }
      callback(preferences);
      CurrentUserStore.reload();
    },
    (errorThrown) => {
      UserNotification.error(
        `Saving of preferences for "${userName}" failed with status: ${errorThrown}`,
        "Could not save user preferences"
      );
    }
  );
};
